export default "__VITE_ASSET__Dfix$RXW__"